import React from 'react'
import { useState, useEffect } from 'react'
import { Routes, Route, NavLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import SecInsurance from '../pages/SecInsurance';
import PatientDashboard from '../pages/PatientDashboard';
import PrimaryInsurance from '../pages/PrimaryInsurance';


import { useDispatch, useSelector } from 'react-redux';
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'



const PatientInsTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [claimCountData, setclaimCountData] = useState('');

  const [patientId, setPatientId] = useState(null);
  const [secondaryInsData, setSecondaryInsData] = useState([]);

 
  const { id } = useParams();
 
  const dispatch = useDispatch();


  const userData = useSelector((state) => state.user.user);
 
  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;
  
  const pendingClaim = useSelector((state) => state.user.filterTableDetails);
  const rejectedCount = useSelector((state) => state.user.rejectedClaim);

   const sAuthToken = useSelector((state) => state.user.token);
  
  // const claimId = useSelector((state) => state.user.claimId);

 
  useEffect(() => {
    const storedPatientId = localStorage.getItem("PatientId");
    setPatientId(storedPatientId);
}, []);
 
  
  

  useEffect(() => {
    document.title ='Patient Portal - Patient Insurance'
  
    const currentTab = location.pathname.split('/').pop(); 
    setActiveTab(currentTab);

   
    if (!currentTab) {
      navigate(`${id}/primary-insurance`);
    }
  }, [location, id, navigate]);




  

  const handleGetPatInsurance = async () => {


    console.log("GetPrimaryInsurance id", id);

 



    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${id}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
       const filterData = parsedData.filter(item => item.InsType == 2)

      
        setSecondaryInsData(filterData);


        console.log("GetPrimaryInsurance of" + CommonAPIConstants.GetPatInsuranceDetails, filterData);




      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  useEffect(() => {

    handleGetPatInsurance();


  }, [])




  

    


  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(`/patient-insurance/${id}/${tab}`);
  };



  return (
    <>


         <div className='topnavmenu text-center'>
                    <label style={{fontSize:'1.2rem', marginTop:'10px', textAlign:'center', textTransform:'uppercase'}}> Patient Portal - Patient Insurance </label>
            </div>
    
      
      <ul className="nav nav-pills mt-1 nav-style" id="pills-tab" role="tablist" >
       

       
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'primary-insurance' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-profile"
            aria-selected={activeTab === 'primary-insurance'}
            onClick={() => handleTabClick('primary-insurance')}
          >
           Primary Insurance
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'secondary-Insurance' ? 'active-tab' : ''}`}            
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'secondary-Insurance'}
            onClick={() => handleTabClick('secondary-Insurance')}
          >
             <label  className={ secondaryInsData.length> 0 ? 'SecInsData' : ''}>  Secondary Insurance </label>
          </a>
        </li>
        
       
      </ul>


      <div className="tab-content" id="pills-tabContent" >
        <Routes>
         
          <Route path="primary-insurance" element={<PrimaryInsurance/>} />
          <Route path="secondary-insurance" element={<SecInsurance/>} />
          
        </Routes>
      </div>
    </>
  )
}

export default PatientInsTab
